<template>
  <div>
    <div v-if="warningZone">
      deconnecter<span id="SecondsUntilExpire">{{ IDLE_TIMEOUT }} </span>
      seconds.
    </div>
  </div>
</template>

<script>
export default {
  name: "AutoLogout",
  data: function () {
    return {
      events: ["click", "mousemove", "mousedown", "scroll", "keypress", "load"],
      warningTimer: null,
      logoutTimer: null,
      warningZone: false,
      IDLE_TIMEOUT: 60,

      idleSecondsTimer: 0,
      idleSecondsCounter: 0,
    };
  },
  computed: {
    second() {
      return this.warningTimer / 1000;
    },
  },
  mounted() {
    setInterval(() => {
      this.IDLE_TIMEOUT++;
    }, 1000);

    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.setTimers();
  },
  destroyed() {
    this.events.forEach(function (event) {
      window.removeEventListener(event, this.resetTimer);
    }, this);
    this.resetTimer();
  },
  methods: {
    setTimers: function () {
      this.warningTimer = setTimeout(this.warningMessage, 29 * 60 * 1000); // 14 minutes - 14 * 60 * 1000
      this.logoutTimer = setTimeout(this.logoutUser, 30 * 60 * 1000); // 15 minutes - 15 * 60 * 1000
      this.warningZone = false;
    },
    warningMessage: function () {
      this.warningZone = true;

      this.$fire({
        title: this.$store.state.user.nom,
        text: "Êtes-vous toujours avec nous? sera expirer dans 1 mn",
        type: "info",
        timer: 60000,
      }).then((r) => {
        console.log(r.value);
      });
    },
    logoutUser: function () {
      this.$fire({
        title: this.$store.state.user.nom,
        text: "OPS! Session expirer essayer de vous reconnecter",
        type: "info",
        timer: 900000,
      }).then((r) => {
        console.log(r.value);
      });
      this.$store
        .dispatch("performLogoutAction")
        .then((res) => {
          this.$noty.success("Déconnexion réussie.");
          this.$router.push("/");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetTimer: function () {
      clearTimeout(this.warningTimer);
      clearTimeout(this.logoutTimer);
      this.setTimers();
    },
  },
};
</script>
<style>
#SecondsUntilExpire {
  background-color: yellow;
}
</style>